import React from 'react';
import { FormMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import styled from 'styled-components';

import { CustomFieldBadge } from '../../../../../atoms/CustomFieldBadge';
import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { NO_VALUE_SENTINEL } from '../../../../../../services/contacts/filters';

const LabelWrapper = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
  min-width: 0;
`;

const LabelText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const formSchema = Yup.object().shape({
  selectedOptions: Yup.array().of(
    Yup.object().shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    }),
  ),
});

export const CustomFieldSingleSelect = ({ value, setFilters, field }) => {
  const filterKey = `customFields_${field.id}`;

  const options = [
    { label: 'No value', value: NO_VALUE_SENTINEL },
    ...(field.params?.options || []).map((option) => ({
      label: option.label,
      value: option.id,
    })),
  ];

  const onSubmit = ({ selectedOptions }) => {
    setFilters({ [filterKey]: selectedOptions });
  };

  const scopeLabel = field.sharedList?.id ? 'List-specific' : 'Global';

  return (
    <Formik
      initialValues={{ selectedOptions: value || [] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="selectedOptions"
          label={
            <LabelWrapper>
              <LabelText title={field.name}>{field.name}</LabelText>

              <CustomFieldBadge>{scopeLabel}</CustomFieldBadge>
            </LabelWrapper>
          }
          placeholder="Select"
          size="small"
          component={FormMultiSelect}
          options={options}
          anchorToBody
          isSearchable={options.length > 5}
        />
      </Form>
    </Formik>
  );
};

CustomFieldSingleSelect.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
  field: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    params: PropTypes.shape({
      options: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          label: PropTypes.string.isRequired,
        }),
      ),
    }),
    sharedList: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  }).isRequired,
};

CustomFieldSingleSelect.defaultProps = {
  value: [],
};
